import { call, put, takeEvery } from "redux-saga/effects";
import { getAuthUserDetails } from "../../utils/Helpers";
import AXIOS_INSTANCE from "../../utils/USOBConfig";

import {
  ChecklistLoading,
  submitChecklistActionDispatcher,
  submitChecklistErrorDispatcher,
  checklistDownloadPdfActionDispatcher,
  SUBMIT_CHECKLIST_ACTION_REQUESTED,
  SUBMIT_CHECKLIST_DOWNLOAD_PDF_ACTION_REQUESTED,
  CHECKLIST_DOWNLOAD_PDF_ACTION_REQUESTED,
  SUBMIT_CHECKLIST_DOWNLOAD_EXCEL_ACTION_REQUESTED,
} from "./Action"; // Path should come here

const postEventAPI = async (filterValues) => {
  let cid =
    localStorage.getItem("defPortal") === "USOB"
      ? getAuthUserDetails()?.usob_cid
      : getAuthUserDetails().CustomerId;

  let src = localStorage.getItem("defPortal") === "USOB" ? "PWA" : "Uptime";

  const isAdmin = getAuthUserDetails()?.IsAdmin;

  let baseURL = `/checklist?source=${encodeURIComponent(src)}`;
  if (!isAdmin) {
    baseURL += `&customer_id=${encodeURIComponent(cid)}`;
  }

  // Filter out undefined, null, or empty strings
    const cleanedParams = {};
    for (const key in filterValues) {
      const value = filterValues[key];
      if (value !== undefined && value !== null && value !== "") {
        cleanedParams[key] = value;
      }
    }
  
    const queryParams = new URLSearchParams(cleanedParams).toString();
    const finalURL = baseURL + (queryParams ? `&${queryParams}` : "");
  
    const result = await AXIOS_INSTANCE.get(finalURL);
    return result;
};

const postDownloadAPI = async (postData) => {
  const result = await AXIOS_INSTANCE.post(`/checklist/export/multiple/pdf`, {
    ...postData,
  });
  return result;
};

const postDownloadExcelAPI = async (postData) => {
  const result = await AXIOS_INSTANCE.post(
    `/checklist/export-checklists/excel`,
    {
      ...postData,
    }
  );
  return result;
};

function* submitEventSaga({ postData }) {
  try {
    yield put(ChecklistLoading(true));
    const data = yield call(postEventAPI, postData);
    yield put(submitChecklistActionDispatcher(data));
    yield put(submitChecklistErrorDispatcher({}));
    yield put(ChecklistLoading(false));
  } catch (e) {
    yield put(submitChecklistActionDispatcher({}));
    yield put(
      submitChecklistErrorDispatcher(e.response.data, console.log(e.response))
    );
    yield put(ChecklistLoading(false));
  }
}
function* downloadChecklistPDF({ postData }) {
  try {
    yield put(ChecklistLoading(true));
    const data = yield call(postDownloadAPI, postData);
    const base64Data = data?.data?.base64;
    const fileName = `checklist.pdf`;

    // Convert base64 to Blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    // Trigger download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // OR use native way below
  } catch (e) {
    yield put(
      submitChecklistErrorDispatcher(e.response.data, console.log(e.response))
    );
    yield put(ChecklistLoading(false));
  }
}
function* downloadChecklistExcel({ postData }) {
  console.log(postData);
  try {
    yield put(ChecklistLoading(true));
    const data = yield call(postDownloadExcelAPI, postData);
    const base64Data = data?.data?.base64;

    const fileName = `checklist.xlsx`;

    // Convert base64 to Blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Trigger download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (e) {
    yield put(
      submitChecklistErrorDispatcher(e.response.data, console.log(e.response))
    );
    yield put(ChecklistLoading(false));
  }
}

function* submitEventWatcher() {
  yield takeEvery(SUBMIT_CHECKLIST_ACTION_REQUESTED, submitEventSaga);
  yield takeEvery(
    SUBMIT_CHECKLIST_DOWNLOAD_PDF_ACTION_REQUESTED,
    downloadChecklistPDF
  );
  yield takeEvery(
    SUBMIT_CHECKLIST_DOWNLOAD_EXCEL_ACTION_REQUESTED,
    downloadChecklistExcel
  );
}
export default submitEventWatcher;
